import React from "react";
import { ReactComponent as YourSvg } from "../icon.svg";

const ArchivedPageWarning: React.FunctionComponent = () => {
  const workspaceManagementUrl =
    "https://m365management.intel.com/";

    const ownershipTool =
    "https://apps.powerapps.com/play/e/c57452c8-1d59-4cc7-bb06-dd1bd68f06bf/a/b5694dea-0009-4169-8dbe-6f5f2515a328?tenantId=46c98d88-e344-4ed4-8496-4ed7712e255d&hint=2d2ed316-1d88-44f8-a5da-f63591efd19d&source=sharebutton&sourcetime=1787595565108";

  const workspaceReactivationUrl =
    "https://intel.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=c174d5c41beeda101e4a0e13604bcb27&sysparm_preview=true&sysparm_domain_restore=false&sysparm_stack=no";

  const archiveInformationUrl =
    "https://intel.sharepoint.com/sites/O365Help/SitePages/Archive-M365-Workspaces.aspx";

  const linkStyle: React.CSSProperties = {
    color: "#0078d4",
    textDecoration: "none",
    fontWeight: 600,
  };

  const primaryButtonStyle: React.CSSProperties = {
    display: "inline-block",
    padding: "10px 18px",
    borderRadius: "8px",
    backgroundColor: "#0078d4",
    color: "#ffffff",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "13px",
    margin: "4px",
  };

  const secondaryButtonStyle: React.CSSProperties = {
    display: "inline-block",
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid #0078d4",
    backgroundColor: "#ffffff",
    color: "#0078d4",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "13px",
    margin: "4px",
  };

  const createLink = (
    url: string,
    text: string,
    style: React.CSSProperties
  ): React.ReactElement => {
    return React.createElement(
      "a",
      {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: style,
      },
      text
    );
  };

  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Arial, sans-serif',
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
        padding: "40px 15px 20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "820px",
          margin: "0 auto",
          padding: "10px",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
            padding: "20px 25px",
          }}
        >
          {/* Icon */}
          <div
            className="row"
            style={{
              textAlign: "center",
              display: "block",
              margin: "0 auto 10px",
            }}
          >
            <YourSvg
              style={{
                width: "120px",
                height: "120px",
              }}
            />
          </div>

          {/* Title */}
          <div style={{ textAlign: "center" }}>
            <h2
              style={{
                color: "#1f2937",
                fontSize: "28px",
                fontWeight: 600,
                margin: "0 0 8px",
              }}
            >
              This workspace is archived
            </h2>

            <div
              style={{
                color: "#6b7280",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              This workspace is currently in archive mode and must be reactivated
              before changes can be made.
            </div>
          </div>

          {/* Information box */}
          <div
            style={{
              border: "1px solid #d9e8fb",
              backgroundColor: "#fafcff",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            {/* Administrator section */}
            <div style={{ marginBottom: "15px" }}>
              <h5
                style={{
                  color: "#1f2937",
                  fontSize: "18px",
                  fontWeight: 600,
                  margin: "0 0 8px",
                }}
              >
                Want to Reactivate It?
              </h5>
              

              <p
                style={{
                  color: "#4b5563",
                  fontSize: "14px",
                  lineHeight: 1.5,
                  margin: "5px 0",
                }}
              >
                If you are the{" "}
                <strong>Site Collection Administrator</strong>, you can
                reactivate this workspace using the{" "}
                {createLink(
                  workspaceManagementUrl,
                  "Workspace Management Tool",
                  linkStyle
                )}
                .
              </p>
            </div>

            <hr
              style={{
                border: "none",
                borderTop: "1px solid #e5e7eb",
                margin: "20px 0",
              }}
            />

    {/* Non-administrator section */}
      <p
      style={{
        color: "#4b5563",
        fontSize: "14px",
        lineHeight: 1.5,
        margin: "5px 0",
      }}
    >
      If you are <strong> not a Site Collection Administrator,</strong> please use
      the{" "}
      {createLink(
        ownershipTool,
        "Ownership Tool",
        linkStyle
      )}{" "}
      to identify the current workspace owners.
    </p>

      <ol
        style={{
          color: "#374151",
          fontSize: "14px",
          lineHeight: 1.5,
          marginTop: "8px",
          marginBottom: "8px",
          paddingLeft: "20px",
        }}
      >
        <li style={{ marginBottom: "6px" }}>
          Open the Ownership Tool.
        </li>

        <li style={{ marginBottom: "6px" }}>
          Search for this workspace.
        </li>

        <li style={{ marginBottom: "6px" }}>
          Contact one of the listed owners and request that they reactivate the
          workspace.
        </li>

        <li style={{ marginBottom: "6px" }}>
          If no owners are displayed, submit a Consultation Request.
        </li>
      </ol>
    </div>

    <hr
      style={{
        border: "none",
        borderTop: "1px solid #e5e7eb",
        margin: "20px 0",
      }}
    />
          

          {/* Action buttons */}
          <div
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            {createLink(
              ownershipTool,
              "Find Workspace Owners",
              primaryButtonStyle
            )}

            {createLink(
              workspaceReactivationUrl,
              "Submit Consultation Request",
              secondaryButtonStyle
            )}
          </div>

          {/* Footer */}
          <div
            style={{
              textAlign: "center",
              marginTop: "12px",
              color: "#6b7280",
              fontSize: "12px",
            }}
          >
            Learn more about the Microsoft 365 archive process{" "}
            {createLink(
              archiveInformationUrl,
              "here",
              linkStyle
            )}
            .
          </div>
        </div>
      </div>
      </div>
  );
};

export default ArchivedPageWarning;